<template>
  <div class="subscriptions-page">
    <div class="subscriptions-header">
      <div class="title">
        <h1 class="text-xl font-semibold">
          {{ $t('hit-admin.common.subscriptions') }}
        </h1>
      </div>

      <div class="controls">
        <hit-select
          class="min-w-[28rem] w-full"
          :label="$t('hit-admin.subscriptions.selectView')"
          :options="viewOptions"
          :value="selectedViewId"
          item-id-property="id"
          :label-fields="['label']"
          :clearable="false"
          @change="onViewChange"
        />
      </div>
    </div>

    <div class="subscriptions-body">
      <company-service-panel v-if="selectedViewId === 'recent'" mode="recent" />
      <company-service-panel
        v-else-if="selectedViewId === 'by_company'"
        mode="by_company"
      />
      <historical-usage-panel
        v-else-if="selectedViewId === 'historical_usage'"
      />
      <current-month-forecast-panel
        v-else-if="selectedViewId === 'current_month_forecast'"
      />
      <blacklist-companies v-else-if="selectedViewId === 'blacklist'" />
      <ho-licence-panel v-else-if="selectedViewId === 'ho_licences'" />
    </div>
  </div>
</template>

<script>
import {defineComponent} from 'vue';
import {HitSelect} from '@hit/components';
import CompanyServicePanel from './company-service/CompanyServicePanel.vue';
import BlacklistCompanies from './company-service/BlacklistCompanies.vue';
import HistoricalUsagePanel from './usage-analytics/HistoricalUsagePanel.vue';
import CurrentMonthForecastPanel from './usage-analytics/CurrentMonthForecastPanel.vue';
import HoLicencePanel from './ho-licence/HoLicencePanel.vue';

export default defineComponent({
  name: 'SubscriptionsPage',
  components: {
    HitSelect,
    CompanyServicePanel,
    BlacklistCompanies,
    HistoricalUsagePanel,
    CurrentMonthForecastPanel,
    HoLicencePanel,
  },
  data() {
    return {
      selectedViewId: 'recent',
    };
  },
  computed: {
    viewOptions() {
      return [
        {
          id: 'recent',
          label: this.$t('hit-admin.subscriptions.views.recent'),
        },
        {
          id: 'by_company',
          label: this.$t('hit-admin.subscriptions.views.byCompany'),
        },
        {
          id: 'blacklist',
          label: this.$t('hit-admin.subscriptions.views.blacklist-companies'),
        },
        {
          id: 'historical_usage',
          label: this.$t('hit-admin.subscriptions.views.historicalUsage'),
        },
        {
          id: 'current_month_forecast',
          label: this.$t('hit-admin.subscriptions.views.currentMonthForecast'),
        },
        {
          id: 'ho_licences',
          label: this.$t('hit-admin.subscriptions.views.hoLicences'),
        },
      ];
    },
  },
  methods: {
    onViewChange(value) {
      if (value) this.selectedViewId = value;
    },
  },
});
</script>

<style lang="scss" scoped>
.subscriptions-page {
  padding: 0.75rem;
  height: 100%;
  display: grid;
  grid-template-rows: max-content minmax(0, 1fr);
  gap: 0.75rem;
}

.subscriptions-header {
  display: grid;
  gap: 0.5rem;
  padding: 0.5rem 0.65rem 0.65rem;
  border-bottom: 1px solid rgba(15, 23, 42, 0.08);
  background: rgba(255, 255, 255, 0.72);
  backdrop-filter: blur(6px);
  border-radius: 0.75rem;
}

.controls {
  display: flex;
  align-items: flex-end;
  flex-wrap: wrap;
  gap: 0.85rem;
}

.subscriptions-body {
  min-height: 0;
  overflow: auto;
}
</style>
